<template>
    <main role="main">
      <div class="container py-4" style="max-width: 700px;">
        <h4 class="mb-4">Cài đặt tài khoản mặc định</h4>
        <div v-if="isLoading" class="py-5 text-center"><b-spinner/></div>
        <b-form v-if="!isLoading && currentDefaultAccount" @keydown="formKeyDown" @submit.prevent="submitForm">
        <b-form-group label-for="input-password-pattern" :label="$t('username')">
          <b-form-input id="input-password-pattern" type="text" v-model="username" name="username" maxlength="32"/>
        </b-form-group>
        <b-form-group label-for="input-password" :label="$t('password')">
            <div class="input-group">
                <b-form-input id="input-password" :type="showPassword ? 'text' : 'password'" class="form-control" maxlength="32"
                        v-model="password" name="password"></b-form-input>
                    <div class="password-eye">
                        <div class="input-group-append">
                        <div class="input-group-text" @click="showPassword = !showPassword">
                            <span class="fas" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"></span>
                        </div>
                        </div>
                    </div>
            </div>
        </b-form-group>
        <!-- <b-form-group label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="7" style="align-items: center;"
            label-for="input-password-pattern" :label="$t('activeStatus')">
            <b-form-checkbox size="lg" switch class="mr-n2" v-model="active" style="align-self: center;">
                <span class="sr-only">Switch for following text input</span>
            </b-form-checkbox>
        </b-form-group> -->
        <div class="check-status">
            <label class="label-status">{{ $t('activeStatus') }}</label>
            <b-form-checkbox size="lg" switch class="mr-n2" v-model="active" style="align-self: center;"></b-form-checkbox>
        </div>
        <p><i>{{ $t('lastUpdate') }}: {{ localDateTimeFormat(modifiedAt) }}</i></p>
          <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>
  
          <div class="text-center pt-3">
            <b-button variant="outline-primary" style="width: 120px; margin-right: 10px;"
                      @click="testAccount">{{ $t("test") }}</b-button>
            <b-button type="submit" variant="primary" style="width: 120px;"
                      :disabled="isSubmitting">{{ $t("save") }}</b-button>
          </div>
        </b-form>
      </div>
    </main>
  
  </template>
  
  <style lang="scss" scoped>
.password-eye {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}
.check-status {
    display: flex;
    align-self: center;
    margin-bottom: 3em;
}
.label-status {
    margin-right: 15px;
    margin-bottom: 0;
    padding-top: 5px;
}
</style>
  
  <script lang="ts">
import { Component, Emit, Prop } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import * as defaultPolicyService from "@/service/defaultAccountService";
import * as userService from "@/service/userService";

@Component
export default class DefaultAccount extends BaseComponent {

    isLoading = true;

    currentDefaultAccount = null;

    formErrorMsg = null;

    isSubmitting = false;

    showPassword = false;

    active = false;
    
    username = '';

    password= '';

    // Emit decorators only
    @Emit("submitted") __submitted() { }


    mounted() {
        this.fetchDefaultAccount();
    }

    async fetchDefaultAccount() {
        try {
            this.isLoading = true;
            this.currentDefaultAccount = await defaultPolicyService.get();
              Object.assign(this, this.currentDefaultAccount);
            this.username = this.currentDefaultAccount.username;
            this.password = this.currentDefaultAccount.password;
            if (this.currentDefaultAccount.status == 1) {
                this.active = true;
            }
            else {
                this.active = false;
            }
        } catch (e) {
            console.error(e);

        } finally {
            this.isLoading = false;
        }
    }

    formKeyDown(event) {
        return event.key !== 'Enter';
    }

    async testAccount() {
        try {
            const user = await userService.testAccount(this.username, this.password);
            if(!user.mustChangePassword) {
                this.toastSuccessDelay('Tài khoản hoạt động bình thường');
            }
            else {
                this.toastError('Mật khẩu đã hết thời gian hiệu lực, xin vui lòng thay tài khoản mới');
            }
        }
        catch (e) {
            this.toastError(e);
        }
    }

    async submitForm() {
        // check regexp

        try {
            this.isSubmitting = true;

            const body = {
                username: this.username,
                password: this.password,
                status: this.active ? 1 : 0
            };
            await defaultPolicyService.set(body);
            this.toastSuccessDelay(this.$t("saveSettingsSuccessful").toString(), null, 0);
            this.fetchDefaultAccount();

        } catch (e) {
            this.toastError(e);

        } finally {
            this.isSubmitting = false;
        }
    }

}
</script>
  